import React, { useState, useEffect } from 'react';
import instagram from '../assets/instagram.png';
import github from '../assets/github.png';
import linkedin from '../assets/linkedin.webp';

export default function Contact() {
  const [emailText, setEmailText] = useState('gavindmilligan@gmail.com');
  const [opacity, setOpacity] = useState(1);
  const [isCopied, setIsCopied] = useState(false);
  const [shouldShake, setShouldShake] = useState(false);
  const isSmallScreen = window.innerWidth <= 768;
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    const handleContactScroll = () => {
      setShouldShake(true);
      setTimeout(() => {
        setShouldShake(false);
      }, 1400); // Match animation duration (1.0s)
    };

    window.addEventListener('contactScroll', handleContactScroll);
    return () => {
      window.removeEventListener('contactScroll', handleContactScroll);
    };
  }, []);

  const copyToClipboard = (text: string) => {
    /* Copy email animation */
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
      setOpacity(0); // Start fading out
      setTimeout(() => {
        setEmailText('Copied!');
        setOpacity(1); // Start fading in
        setTimeout(() => {
          setOpacity(0); // Start fading out again after 2 seconds
          setTimeout(() => {
            setEmailText('gavindmilligan@gmail.com');
            setOpacity(1); // Fade back in to show the email
            setIsCopied(false);
          }, 250); // Match this duration with the CSS transition duration
        }, 1000);
      }, 250); // Match this duration with the CSS transition duration
    });
  };

  return (
<div style={{ zIndex: 10, position: 'relative', marginTop: '10vh', marginBottom: '10vh', paddingBottom: '10vh' }}>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '40px', zIndex: 10, position: 'relative'}}>
            <div style={{
                width: isSmallScreen ? '55px' : 'clamp(80px, 25vw, 600px)',
                height: '3px',
                backgroundColor: '#333333',
            }}></div>
            <div className={shouldShake ? 'contact-shake' : ''} style={{fontSize: isSmallScreen ? '35px' : '55px', color: '#333333', textAlign: 'center', transformOrigin: 'center center', display: 'inline-block'}}>
                Contact
            </div>
            <div style={{
                width: isSmallScreen ? '55px' : 'clamp(80px, 25vw, 600px)',
                height: '3px',
                backgroundColor: '#333333',
            }}></div>
        </div>
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
    <div
      style={{
        border: '2px solid #333333',
        borderRadius: '10px',
        color: '#333333',
        display: 'inline-block',        // Makes border width fit text
        padding: '5px 20px',            // Adds padding for spacing
        textAlign: 'center'
      }}
    >
      <div
        style={{
          fontSize: isSmallScreen ? '18px' : '25px',
          paddingBottom: '5px',
          paddingTop: '5px',
          cursor: 'pointer',
          textAlign: 'center',
          opacity: opacity,
          transition: 'opacity 0.5s ease'
        }}
        onClick={() => copyToClipboard('gavindmilligan@gmail.com')}
      >
        {emailText}
        <div style={{ visibility: 'hidden', height: 0 }}>{'gavindmilligan@gmail.com'}</div>
      </div>
    </div>
  </div>

  <div style={{display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: isMobile ? 'center' : 'flex-start',
                gap: isMobile ? '30px': '120px',
                justifyContent: 'center',
                zIndex: 10,
                position: 'relative',
                marginTop: isMobile ? '30px' : '40px'}}>
            <a href="https://www.linkedin.com/in/gavin-d-milligan/" target="_blank" rel="noopener noreferrer">
                <img src={linkedin} 
                alt="Linkedin icon"
                style={{ width: '40px', height: 'auto', cursor: 'pointer',
                    filter: 'invert(58%) brightness(50%)',
                 }} />
            </a>

            <a href="https://github.com/hashedonemilliontimes" target="_blank" rel="noopener noreferrer">
                <img src={github} 
                alt="Github icon"
                style={{ width: '40px', height: 'auto', filter: 'invert(18%)' }} />
            </a>

            <a href="https://www.instagram.com/gavmilligan/?hl=en" target="_blank" rel="noopener noreferrer">
                <img src={instagram} 
                alt="Instagram icon"
                style={{ width: '40px', height: 'auto', filter: 'invert(58%) brightness(50%)', }} />
            </a>
            </div>
</div>

  );
}
